/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Inherited_Suffix_UserInputs */

const en_settings_inherited_suffix_user = /** @type {(inputs: Settings_Inherited_Suffix_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. To overwrite it for this user, set it below.`)
};

const de_settings_inherited_suffix_user = /** @type {(inputs: Settings_Inherited_Suffix_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` gesetzt. Um sie für diesen Benutzer zu überschreiben, setzen Sie sie unten.`)
};

/**
* | output |
* | --- |
* | ". To overwrite it for this user, set it below." |
*
* @param {Settings_Inherited_Suffix_UserInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const settings_inherited_suffix_user = /** @type {((inputs?: Settings_Inherited_Suffix_UserInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Inherited_Suffix_UserInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_inherited_suffix_user(inputs)
	return de_settings_inherited_suffix_user(inputs)
});